export default __webpack_public_path__ + "assets/a67b1a47ab061817477e5946fc0552c3.svg";